import { render, staticRenderFns } from "./TextareaElement.vue?vue&type=template&id=57b2085f&scoped=true&"
import script from "./TextareaElement.vue?vue&type=script&lang=js&"
export * from "./TextareaElement.vue?vue&type=script&lang=js&"
import style0 from "./TextareaElement.vue?vue&type=style&index=0&id=57b2085f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b2085f",
  null
  
)

export default component.exports